import callApi from './personnelService';
const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/member`;

export const getStores = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-stores`,
  body: storeInfo
});

export const getStorePersonnel = (store_id) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-personnel`,
  body: {
    store_id
  }
});
